import { createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "flex flex-col justify-between h-full" }
const _hoisted_2 = { class: "px-6 md:px-8 pt-6 pb-20 max-w-6xl" }
const _hoisted_3 = { key: 0 }

import { computed, onMounted, watch } from 'vue'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'

import ReportDownloadHistory from '@/components/reports/ReportDownloadHistory.vue'
import ReportsGroup from '@/components/reports/ReportsGroup.vue'
import SecondaryNav from '@/components/SecondaryNav.vue'
import SecondaryTop from '@/components/SecondaryTop.vue'
import { reportGroupsList } from '@/config/reportGroups'
import privilegeService from '@/services/privilege.service'
import api from '@/store/api'


export default {
  __name: 'ReportsNeue',
  setup(__props) {

const router = useRouter()
const store = useStore()

const canReadReports = computed(() => privilegeService.canAccessResourceAction('reports', null, 'read'))

watch(
  () => store.state.hideNumbers,
  hideNumbers => {
    if (hideNumbers) {
      router.push('/orders')
    }
  },
  { immediate: true }
)

onMounted(() => {
  if (canReadReports.value) {
    api.call('GET', 'data_downloads')
  }
})

return (_ctx, _cache) => {
  return (_openBlock(), _createBlock(SecondaryNav, null, {
    top: _withCtx(() => [
      _createVNode(SecondaryTop, { text: "Reports" })
    ]),
    main: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (canReadReports.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(reportGroupsList), (group) => {
                  return (_openBlock(), _createBlock(ReportsGroup, {
                    key: group.title,
                    title: group.title,
                    subtitle: group.subtitle,
                    reports: group.reports
                  }, null, 8, ["title", "subtitle", "reports"]))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          _createVNode(ReportDownloadHistory, {
            "button-label": "+ Report",
            "header-name": "Data exports"
          })
        ])
      ])
    ]),
    _: 1
  }))
}
}

}